import ACTIONS from "../../constants/constants"

const initProdsState = []
export const products2d = (state = initProdsState, action) => {
  const {type, data} = action
  switch (type) {
    case ACTIONS.FETCH_2D_PRODUCTS:
      return data.products
    default:
      return state
  }
}

const initState = {
  name: "",
  label: "",
  size: "",
  color: "",
  price: 0,
  partPrice: null,
  parts: [],
}

export const product2d = (state = initState, action) => {
  const {type, payload, data} = action
  switch (type) {
    case ACTIONS.SET_2D_PRODUCT:
      return {
        ...state,
        ...payload,
      }
    case ACTIONS.FETCH_2D_PRODUCT:
      return {
        ...state,
        parts: data,
      }
    case ACTIONS.CLEAR_2D_PRODUCT:
      return initState
    default:
      return state
  }
}

const activePartInit = null
export const product2dActivePart = (state = activePartInit, action) => {
  const {type, payload} = action

  switch (type) {
    case ACTIONS.PRODUCT_2D_SET_ACTIVE_PART:
      return payload
    case ACTIONS.PRODUCT_2D_CLEAR_ACTIVE_PART:
      return activePartInit
    default:
      return state
  }
}

const canvasStateInit = []
export const product2dCanvasState = (state = canvasStateInit, action) => {
  const {type, payload} = action

  switch (type) {
    case ACTIONS.PRODUCT_2D_SET_CANVAS_STATE:
      return [...payload]
    case ACTIONS.PRODUCT_2D_CLEAR_CANVAS_STATE:
      return canvasStateInit
    default:
      return state
  }
}

const LWAInit = null
export const LWAState = (state = LWAInit, action) => {
  const {type, payload} = action

  switch (type) {
    case ACTIONS.P_2D_SET_LEFTWORKAREA_STATE:
      return payload
    case ACTIONS.P_2D_CLEAR_LEFTWORKAREA_STATE:
      return LWAInit
    default:
      return state
  }
}

const BaseColorInit = {color: "#FFFFFF", label: "White"}
export const product2dBaseColor = (state = BaseColorInit, action) => {
  const {type, payload} = action

  switch (type) {
    case ACTIONS.PRODUCT_2D_SET_BASE_COLOR:
      return {...payload}
    case ACTIONS.PRODUCT_2D_CLEAR_BASE_COLOR:
      return BaseColorInit
    default:
      return state
  }
}

const activeObjInit = null
export const activeObj = (state = activeObjInit, action) => {
  const {type, payload} = action

  switch (type) {
    case ACTIONS.P_2D_SET_ACTIVE_OBJECT:
      return payload
    case ACTIONS.P_2D_CLEAR_ACTIVE_OBJECT:
      return activeObjInit
    default:
      return state
  }
}

export const activeObjs = (state = [], action) => {
  const {type, payload} = action

  switch (type) {
    case ACTIONS.P_2D_SET_ACTIVE_OBJECTS:
      return payload
    case ACTIONS.P_2D_CLEAR_ACTIVE_OBJECTS:
      return []
    default:
      return state
  }
}

export const d2Loader = (state = false, action) => {
  const {type, payload} = action

  switch (type) {
    case ACTIONS.SET_2D_LOADER:
      return payload
    default:
      return state
  }
}
